import { latLng } from 'leaflet';
import Vue from 'vue';
export default {
  data() {
    return {
      searchTitle: '',
      disabelConfirm: false,
      otherOrganizationTableInformationHeader: [
        {
          text: '',
          value: 'icon',
          align: 'center',
          width: '30px',
          sortable: false,
        },
        { text: 'تاریخ', value: 'date', align: 'center', width: '120px' },
        {
          text: 'کد آمبولانس',
          value: 'ambulanceCode',
          align: 'center',
          width: '120px',
        },
        {
          text: 'شماره تماس',
          value: 'phoneNumber',
          align: 'center',
          width: '150px',
        },
        { text: 'شکایت اصلی', value: 'cc', align: 'center', width: '200px' },
        { text: 'آدرس', value: 'address', align: 'center', width: '200px' },
        { text: 'توضیحات', value: 'note', align: 'center', width: '150px' },
        { text: 'ارگان', value: 'organ', align: 'center', width: '120px' },
        {
          text: 'عملیات',
          value: 'actions',
          sortable: false,
          align: 'center',
          width: '120px',
        },
      ],
      otherOrganizationMissions: [],
      missionPhoneId: null,
      missionId: null,
      phoneId: null,
      patientId: null,
      allUserHospitals: [],
      admissionModal: false,
      playSoundList: [],
      soundIsPlay: false,
      redFlag: false,
      yellowFlag: false,
      playInterval: null,
      detailObject: null,
      detailModal: false,
    };
  },
  methods: {
    stopMusic: function () {
      this.soundIsPlay = false;
      clearInterval(this.playInterval);
      this.playSoundList = [];
      this.playInterval = null;
    },
    reloadData: function () {
      clearInterval(this.playInterval);
      this.playSoundList = [];
      this.soundIsPlay = false;
      this.redFlag = false;
      this.yellowFlag = false;
      this.playInterval = null;
      this.getAllActiveMissionOtherOrganizations();
    },
    makeDataReady: function (data) {
      this.otherOrganizationMissions = [];
      for (const item of data) {
        let date = '';
        if (item.missionCreationDate) {
          date = Vue.moment(item.missionCreationDate).format('HH:mm:ss jYYYY/jM/jD');
        }
        let phoneNumber = '';
        if (item.missionCallerId) {
          phoneNumber = item.missionCallerId;
        } else {
          phoneNumber = item.missionOtherPhoneNumber;
        }
        let color = '';
        let missionRank = '';
        if (item.missionRank == 0) {
          color = '#D1D1D1';
          missionRank = 'سفید';
        } else if (item.missionRank == 1) {
          color = '#3BCA79';
          missionRank = 'سبز';
        } else if (item.missionRank == 3) {
          color = '#F56060';
          missionRank = 'قرمز';
          if (this.playSoundList.length == 0) {
            let flag = false;
            for (let j = 0; j < this.playSoundList.length; j++) {
              if (item.id == this.playSoundList[j]) {
                flag = true;
              }
            }
            if (flag == false) {
              this.playSoundList.push(item.id);
              if (!this.soundIsPlay || !this.redFlag) {
                this.soundIsPlay = true;
                clearInterval(this.playInterval);
                this.playInterval = null;
                this.playInterval = setInterval(() => {
                  this.playSound();
                }, 1000);
                this.redFlag = true;
              }
            }
          } else {
            this.playSoundList.push(item.id);
            if (!this.soundIsPlay || !this.redFlag) {
              this.soundIsPlay = true;
              clearInterval(this.playInterval);
              this.playInterval = null;
              this.playInterval = setInterval(() => {
                this.playSound();
              }, 1000);
              this.redFlag = true;
            }
          }
        } else if (item.missionRank == 2) {
          color = '#F2BD27';
          missionRank = 'زرد';
          if (this.playSoundList.length == 0) {
            let flag = false;
            for (let j = 0; j < this.playSoundList.length; j++) {
              if (item.id == this.playSoundList[j]) {
                flag = true;
              }
            }
            if (flag == false) {
              this.playSoundList.push(item.id);
              if (!this.soundIsPlay || !this.yellowFlag || !this.redFlag) {
                this.soundIsPlay = true;
                this.playInterval = setInterval(() => {
                  this.playSound();
                }, 2500);
                this.yellowFlag = true;
              }
            }
          } else {
            this.playSoundList.push(item.id);
            if (!this.soundIsPlay || !this.yellowFlag || !this.redFlag) {
              this.soundIsPlay = true;
              this.playInterval = setInterval(() => {
                this.playSound();
              }, 2500);
              this.yellowFlag = true;
            }
          }
        }
        this.otherOrganizationMissions.push({
          rank: item.missionRank,
          missionRank: missionRank,
          color: color,
          date: date,
          ambulanceCode: item.phoneCodes ? item.phoneCodes : '-',
          phoneNumber: phoneNumber ? phoneNumber : '-',
          cc: item.missionDiagnosisTitle ? item.missionDiagnosisTitle : '-',
          address: item.missionAddress ? item.missionAddress : '-',
          note: item.note ? item.note : '-',
          organ: item.otherOrganizationTitle ? item.otherOrganizationTitle : '-',
          complaintText: item.missionChiefComplaintText ? item.missionChiefComplaintText : '-',
          complaintNote: item.missionChiefComplaintNote ? item.missionChiefComplaintNote : '-',
          missionLatitude: item.missionLatitude ? item.missionLatitude : '-',
          missionLongitude: item.missionLongitude ? item.missionLongitude : '-',
        });
      }
    },
    itemRowBackground: function (item) {
      if (item.rank == 3) {
        return 'row-back-red';
      } else if (item.rank == 2) {
        return 'row-back-yellow';
      } else {
        return '';
      }
    },
    showDetailModal: function (data) {
      this.mapInvalidate();
      this.position = latLng(data.missionLatitude, data.missionLongitude);
      this.detailObject = data;
      this.detailModal = true;
    },
    closeDetailModal: function () {
      this.position = null;
      this.detailObject = null;
      this.detailModal = false;
    },
  },
};
